import React, { useEffect, useState } from "react";
import "./ProfilePage.css";

const ProfilePage = () => {
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    phone: "",
    role: "",
    address: "",
    pincode: "",
    avatar: "",
  });

  const API_URL = process.env.REACT_APP_API_URL;

  // ✅ Load user from sessionStorage
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      setProfile({
        name: user.name || "",
        email: user.email || "",
        phone: user.phone || "",
        role: user.role || "",
        address: user.address || "",
        pincode: user.pincode || "",
        avatar: user.avatar || "",
        _id: user._id || user.id, // ensure we have MongoDB ID
      });
    }
  }, []);

  // ✅ Handle input change
  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  // ✅ Avatar upload
  const handleAvatarChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("avatar", file);

    try {
      const storedUser = JSON.parse(sessionStorage.getItem("user"));
      const userId = storedUser?._id || storedUser?.id; // ✅ use correct id

      const response = await fetch(`${API_URL}/user/upload-avatar/${userId}`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Upload failed: ${errorText}`);
      }

      const data = await response.json();

      // ✅ Update state and sessionStorage
      setProfile((prev) => ({ ...prev, avatar: data.user.avatar }));
      sessionStorage.setItem("user", JSON.stringify(data.user));
      alert("Avatar updated successfully!");
    } catch (error) {
      console.error("Error uploading avatar:", error);
      alert("Failed to upload avatar. Please try again.");
    }
  };

  // ✅ Profile update (sessionStorage only for now)
  const handleProfileUpdate = (e) => {
    e.preventDefault();
    sessionStorage.setItem("user", JSON.stringify(profile));
    alert("Profile updated successfully!");
  };

  return (
    <div className="profile-container">
      <div className="profile-card">
        <h2>My Profile</h2>

        {/* Avatar Upload */}
        <div className="avatar-section">
          <img
            src={profile.avatar}
            alt="Profile Avatar"
            className="avatar"
          />
          <input type="file" accept="image/*" onChange={handleAvatarChange} />
        </div>

        {/* Profile Form */}
        <form onSubmit={handleProfileUpdate} className="profile-form">
          <label>Full Name</label>
          <input
            type="text"
            name="name"
            value={profile.name}
            onChange={handleChange}
            required
          />

          <label>Email</label>
          <input
            type="email"
            name="email"
            value={profile.email}
            onChange={handleChange}
            required
          />

          <label>Phone</label>
          <input
            type="text"
            name="phone"
            value={profile.phone}
            onChange={handleChange}
            required
          />

          <label>Role</label>
          <input type="text" name="role" value={profile.role} disabled />

          <label>Address</label>
          <input
            type="text"
            name="address"
            value={profile.address}
            onChange={handleChange}
          />

          <label>Pincode</label>
          <input
            type="text"
            name="pincode"
            value={profile.pincode}
            onChange={handleChange}
          />

          <button type="submit">Update Profile</button>
        </form>
      </div>
    </div>
  );
};

export default ProfilePage;
